import { Check, X, Stamp } from 'lucide-react';

/**
 * Badge de estado de conciliación de una factura de CxP:
 *  - ✓ Verde  → 'conciliada' (pareada en el estado de cuenta del proveedor)
 *  - ✗ Rojo   → 'no_conciliada' (no llegó estado de cuenta o el folio no aparece)
 *  - V°B° Ámbar → 'vb_forzado' (autorizada manualmente pese a no estar conciliada)
 *
 * Espera el campo `f.vb_estado` que entrega el backend (listar_nominas).
 * Si se pasa `onForce`, el badge (cuando NO está conciliada) se vuelve clickeable
 * para forzar/gestionar el V°B°.
 */
export const ConciliaBadge = ({ factura, onForce }) => {
  const estado = factura?.vb_estado
    || (factura?.concilia_estado === 'conciliada'
      ? 'conciliada'
      : (factura?.vb_forzado ? 'vb_forzado' : 'no_conciliada'));

  const clickable = typeof onForce === 'function' && estado !== 'conciliada';
  const commonClick = clickable
    ? { role: 'button', tabIndex: 0, onClick: (e) => { e.stopPropagation(); onForce(); }, style: { cursor: 'pointer' } }
    : {};

  if (estado === 'conciliada') {
    return (
      <span
        className="inline-flex items-center gap-0.5 text-[9px] font-semibold text-green-700 bg-green-50 border border-green-200 rounded px-1 py-0.5"
        title={`Conciliada — pareada en estado de cuenta${factura?.concilia_detalle ? ` (${factura.concilia_detalle})` : ''}`}
        data-testid={`concilia-badge-${factura?.id}`}
      >
        <Check className="w-3 h-3" /> Conciliada
      </span>
    );
  }
  if (estado === 'vb_forzado') {
    return (
      <span
        className={`inline-flex items-center gap-0.5 text-[9px] font-semibold text-amber-800 bg-amber-100 border border-amber-400 rounded px-1 py-0.5 ${clickable ? 'hover:bg-amber-200' : ''}`}
        title={`V°B° forzado${factura?.vb_forzado_motivo ? `: ${factura.vb_forzado_motivo}` : ''}${factura?.vb_forzado_por ? ` — ${factura.vb_forzado_por}` : ''}${clickable ? ' (click para gestionar)' : ''}`}
        data-testid={`concilia-badge-${factura?.id}`}
        {...commonClick}
      >
        <Stamp className="w-3 h-3" /> V°B° forzado
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-[9px] font-semibold text-red-700 bg-red-50 border border-red-200 rounded px-1 py-0.5 ${clickable ? 'hover:bg-red-100' : ''}`}
      title={`Sin conciliar — no llegó el estado de cuenta del proveedor o el folio no aparece pareado${clickable ? ' (click para forzar V°B°)' : ''}`}
      data-testid={`concilia-badge-${factura?.id}`}
      {...commonClick}
    >
      <X className="w-3 h-3" /> Sin conciliar
    </span>
  );
};
